import React from 'react';
import PropTypes from 'prop-types';
import {Button, Paper, makeStyles} from '@material-ui/core';
import Modal from 'components/common/Modal';
import {useListFacilities} from 'hooks/lists';
import {fetchCommonImages, deleteCommonImage} from 'api/images';
import ReadingReactionForm from './CommonImageForm';
import CommonImageTable from './CommonImageTable';

const useStyles = makeStyles({
  information: {
    padding: 20,
  },
});

const CommonImageList = ({type, tableTitle, createTitle, updateTitle, deletionSuccessMsg}) => {
  const classes = useStyles();
  const {
    tableState,
    refreshTable,
    selectPage,
    selectItemsPerPage,
    changeFilter,
    changeSorter,
    changeExtraFilters,
    modalOpen,
    currentRecord,
    openModal,
    closeModal,
    triggerSoftRefresh,
    deleteRecord,
  } = useListFacilities({
    fetchRecords: ({extraParams = {}, ...rest}, signal) =>
      fetchCommonImages({...rest, extraParams: {...extraParams, type}}, signal),
    deleteFn: deleteCommonImage,
    deletionSuccessMsg,
  });

  return (
    <div>
      <Modal
        title={currentRecord ? updateTitle : createTitle}
        onClose={closeModal}
        open={modalOpen}
        maxWidth="sm"
        renderContent={() => (
          <ReadingReactionForm
            initialValues={currentRecord}
            onCancel={closeModal}
            onSubmitSuccess={triggerSoftRefresh}
            type={type}
          />
        )}
      />
      <div className="container content-box">
        <Paper className={classes.information}>
          <h3 className="section-header">
            <div className="section-title">{tableTitle}</div>
            <Button variant="contained" color="primary" className="pull-right" onClick={() => openModal()}>
              {createTitle}
            </Button>
          </h3>
          <CommonImageTable
            {...{
              tableState,
              refreshTable,
              selectPage,
              selectItemsPerPage,
              changeFilter,
              changeSorter,
              changeExtraFilters,
              showUpdateModal: openModal,
              onDeleteActionClick: deleteRecord,
            }}
          />
        </Paper>
      </div>
    </div>
  );
};

CommonImageList.propTypes = {
  type: PropTypes.string.isRequired,
  tableTitle: PropTypes.string.isRequired,
  createTitle: PropTypes.string.isRequired,
  updateTitle: PropTypes.string.isRequired,
  deletionSuccessMsg: PropTypes.string.isRequired,
};

export default CommonImageList;
